module.exports = __webpack_public_path__ + "media/images/athletes/1743-cc9dd76aed7562de7a2226f6ee88d93d.png";